import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyASMoIEJ-7sAJhQzI_hQaOwW6YBUojwQYQ",
  authDomain: "national-archery.firebaseapp.com",
  databaseURL: "https://national-archery-default-rtdb.firebaseio.com",
  projectId: "national-archery",
  storageBucket: "national-archery.appspot.com",
  messagingSenderId: "1058071199098",
  appId: "1:1058071199098:web:6895235c5edc8947f36ac3",
  measurementId: "G-B28ZKJEP3S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics (optional)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;
